<template>
  <router-view></router-view>
</template>

<script>
import store from '@/store'

export default {
  name: 'Requisition',
  beforeRouteEnter (to, from, next) {
    return store.dispatch('requisitions/setRoute', { to, from, next })
  },
  beforeRouteUpdate (to, from, next) {
    return store.dispatch('requisitions/setRoute', { to, from, next })
  },
  beforeRouteLeave (to, from, next) {
  // called when the route that renders this component is about to
  // be navigated away from.
  // has access to `this` component instance.
    return store.dispatch('requisitions/emptyCurrent')
      .then(r => next())
  }
}
</script>

<style>
</style>
